import React from "react";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export function SidebarSearch({
  searchQuery,
  onChange,
  onClear,
  searchInputRef,
  onInputClick,
  onFocus,
  className,
  trailing = null,
}) {
  const { t } = useTranslation("sidebar");
  return (
    <div className={cn("flex min-w-0 items-center gap-2", className)}>
      <div className="sidebar-search relative min-w-0 flex-1 rounded-[var(--ds-radius-control)] border border-sidebar-border bg-sidebar/80 transition-colors focus-within:border-sidebar-ring focus-within:bg-sidebar-accent focus-within:ring-2 focus-within:ring-sidebar-ring/20 motion-reduce:transition-none">
        <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-sidebar-foreground/60" />
        <input
          ref={searchInputRef}
          type="text"
          placeholder={t("searchPlaceholder", { defaultValue: "Search..." })}
          value={searchQuery}
          onChange={(e) => onChange(e.target.value)}
          onClick={onInputClick}
          onFocus={onFocus}
          className={`h-[var(--ds-density-control-height)] w-full border-0 bg-transparent pl-9 text-[13px] text-sidebar-foreground shadow-none outline-none placeholder:text-sidebar-foreground/60 focus:ring-0 ${searchQuery ? "pr-10" : "pr-3"}`}
        />
        {searchQuery && (
          <button
            type="button"
            onClick={onClear}
            className="absolute right-2 top-1/2 flex size-5 -translate-y-1/2 items-center justify-center rounded-[var(--ds-radius-control-compact)] text-sidebar-foreground/60 transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sidebar-ring motion-reduce:transition-none"
            aria-label={t("searchClear", { defaultValue: "Clear search" })}
          >
            ×
          </button>
        )}
      </div>
      {trailing}
    </div>
  );
}
